import { useQuery } from "@tanstack/react-query";

import type { ResponseError } from "app/services/fetchService";

import type { MethodName, Tag } from "./apiClient";
import type { Args, Data, IQueryParams } from "./queryTypes";
import { getQueryOptions, type QueryOptions } from "./utils";

/**
 * @experimental
 */
export const useApiQuery = <T extends Tag, M extends MethodName<T>, TData = Data<T, M>>(
    params: IQueryParams<T, M, QueryOptions<T, M, TData>>,
    ...args: Args<T, M>
) => useQuery<Data<T, M>, ResponseError, TData>(getQueryOptions(params, ...args));
